// @flow

import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import type { DeletedChecklistField } from "src/types";
import Field from "./Field";

type Props = {
  id: string | number,
  value: DeletedChecklistField,
  position: number,
  index: number,
  updateField: Function,
  restoreField: Function,
};

const SortableItem = ({
  id,
  value,
  position,
  updateField,
  restoreField,
}: Props) => {
  const { listeners, setNodeRef, setActivatorNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Field
      value={value}
      index={position}
      position={position}
      updateField={updateField}
      restoreField={restoreField}
      rowRef={setNodeRef}
      style={style}
      dragHandleRef={setActivatorNodeRef}
      dragHandleListeners={listeners}
    />
  );
};

export default SortableItem;
